import { createReducer, on } from '@ngrx/store';
import { toggleMenu } from '../actions/component.actions';

export interface ComponentsState {
  menu: MenuState;
}

export interface MenuState {
  visible: boolean;
}

export const initialComponentsState: ComponentsState = {
  menu: {
    visible: true
  }
}

export const componentsReducer = createReducer(
  initialComponentsState,
  on(toggleMenu, (state) => ({
    ...state,
    menu: {
      visible: !state.menu.visible
    }
  })),
);
